<app-filtros-reporte>
  <form class="space-y-3 sm:space-y-4" (submit)="aplicarFiltros($event)">
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
      <!-- Rango de fechas y tipo movimiento -->
      <div class="sm:col-span-2 lg:col-span-1">
        <label class="block text-xs sm:text-sm font-medium text-gray-600 mb-2">
          <i class="bi bi-calendar-range"></i>
          Rango de fechas
        </label>
        <div class="flex items-center rounded-lg border border-slate-200 bg-white transition-all duration-150 focus-within:ring-2 focus-within:ring-accent-500/20 focus-within:border-accent-500 hover:border-slate-300">
          <span class="flex items-center justify-center pl-3 pr-2 text-slate-400 shrink-0">
            <i class="bi bi-calendar text-sm"></i>
          </span>
          <app-datepicker
            ngSkipHydration
            class="flex-1"
            [borderless]="true"
            [formField]="$any(formFiltro.rangoFecha)"
            selectionMode="range"
            [maxDate]="maxDate"
            placeholder="Seleccione un rango"
            dateFormat="dd/mm/yy"
            [minDate]="minDate"
            [showButtonBar]="true"
            [invalid]="formFiltro.rangoFecha().touched() && formFiltro.rangoFecha().invalid()"
          />
        </div>
        @if (formFiltro.rangoFecha().touched() && formFiltro.rangoFecha().invalid()) {
          <small class="text-sm text-red-600">{{
            formFiltro.rangoFecha().errors() | formErrorMessage
          }}</small>
        }
      </div>
      <!-- Tipo de movimiento -->
      <!-- <div>
        <label class="block text-sm font-medium text-gray-600 mb-2">
          <i class="bi bi-arrow-left-right"></i>
          Tipo de movimiento
        </label>
        <select
          [(ngModel)]="tipo_movimiento"
          class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-sm"
        >
          <option value="">Todos</option>
          <option value="ingreso">Ingresos</option>
          <option value="egreso">Egresos</option>
          <option value="ajuste">Ajustes</option>
        </select>
      </div> -->
      <!-- Usuario -->
      <div class="sm:col-span-1">
        <label class="block text-xs sm:text-sm font-medium text-gray-600 mb-2">
          <i class="bi bi-person-circle"></i>
          Empleado
        </label>
        <app-select
          class="w-full"
          [options]="optionesEmpleado()"
          [formField]="$any(formFiltro.empleado)"
          [filter]="optionesEmpleado().length > 10"
          filterBy="label"
          emptyFilterMessage="No se encontraron empleados."
          [loading]="!optionesEmpleado().length"
          placeholder="Seleccione un empleado"
        />
      </div>
      <!-- estado cerrado/abierta -->
      <div class="sm:col-span-1">
        <label class="block text-xs sm:text-sm font-medium text-gray-600 mb-2">
          <i class="bi bi-lock-fill"></i>
          Estado de Caja
        </label>
        <app-select
          class="w-full"
          [formField]="$any(formFiltro.estadoCaja)"
          placeholder="Seleccione estado"
          [options]="[
            { label: 'Todos', value: null },
            { label: 'Abierta', value: false },
            { label: 'Cerrada', value: true },
          ]"
        />
      </div>
      <!-- sucursal -->
      <div class="sm:col-span-2 lg:col-span-1">
        <label class="block text-xs sm:text-sm font-medium text-gray-600 mb-2">
          <i class="bi bi-geo-alt"></i>
          Sucursal
        </label>
        <app-select
          class="w-full"
          [options]="opcionesSucursal()"
          [formField]="$any(formFiltro.sucursal)"
          [filter]="opcionesSucursal().length > 10"
          filterBy="label"
          emptyFilterMessage="No se encontraron sucursales."
          [loading]="!opcionesSucursal().length"
          placeholder="Seleccione una sucursal"
        />
      </div>
    </div>

    <!-- Botones de acción -->
    <div class="grid grid-cols-3 sm:grid-cols-3 lg:grid-cols-3 gap-2 sm:gap-3">
      <button
        type="submit"
        class="px-3 sm:px-4 py-2 sm:py-2.5 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center gap-1 sm:gap-2 text-xs sm:text-sm"
      >
        <i class="bi bi-search"></i>
        <span class="hidden sm:inline">Buscar</span>
      </button>
      <button
        type="button"
        (click)="limpiarFiltros()"
        class="px-3 sm:px-4 py-2 sm:py-2.5 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors flex items-center justify-center gap-1 sm:gap-2 text-xs sm:text-sm"
      >
        <i class="bi bi-arrow-clockwise"></i>
        <span class="hidden sm:inline">Limpiar</span>
      </button>
      <button
        type="button"
        (click)="exportarExcel()"
        class="px-3 sm:px-4 py-2 sm:py-2.5 bg-emerald-600 text-white font-medium rounded-lg hover:bg-emerald-700 transition-colors flex items-center justify-center gap-1 sm:gap-2 text-xs sm:text-sm"
      >
        <i class="bi bi-file-earmark-excel"></i>
        <span class="hidden sm:inline">Excel</span>
      </button>
      <!-- <button
        type="button"
        (click)="generarReporte()"
        class="flex-1 px-4 py-2.5 bg-green-600 text-white font-medium rounded-lg hover:bg-green-700 transition-colors flex items-center justify-center gap-2 text-sm"
      >
        <i class="bi bi-file-earmark-pdf"></i>
        <span>PDF</span>
      </button> -->
    </div>
  </form>
</app-filtros-reporte>

<!-- Tarjetas de resumen -->
@if (resumenReporte() != null) {
  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-3 mb-4 sm:mb-6">
    <!-- Ventas realizadas -->
    <div class="rounded-lg shadow-sm p-3 sm:p-4 border-l-4 border-green-500">
      <div class="flex items-center gap-3">
        <div class="flex-1 min-w-0">
          <p class="text-gray-600 text-xs font-medium">
            Ventas realizadas
            <i
              class="bi bi-info-circle text-green-500 text-xs cursor-help"
              appTooltip="Corresponde a la suma de venta.total de todas las ventas realizadas durante los turnos de caja abiertos o cerrados en el periodo filtrado. No incluye egresos ni vuelto."
              tooltipPosition="top"
            ></i>
          </p>
          <p class="text-base sm:text-lg font-bold text-gray-900 mt-1 truncate">
            {{ resumenReporte()!.total_ventas | currency: 'PEN' : 'S/. ' }}
          </p>
        </div>
        <div class="p-2 bg-green-100 rounded shrink-0">
          <i class="bi bi-cash-stack text-green-600 text-lg"></i>
        </div>
      </div>
    </div>

    <!-- Total esperado en sistema -->
    <div class="rounded-lg shadow-sm p-3 sm:p-4 border-l-4 border-blue-500">
      <div class="flex items-center gap-3">
        <div class="flex-1 min-w-0">
          <p class="text-gray-600 text-xs font-medium">Total esperado (sistema)</p>
          <p class="text-base sm:text-lg font-bold text-gray-900 mt-1 truncate">
            {{
              resumenReporte()!.total_esperado_caja ?? resumenReporte()!.total_ventas
                | currency: 'PEN' : 'S/. '
            }}
          </p>
        </div>
        <div class="p-2 bg-blue-100 rounded shrink-0">
          <i class="bi bi-calculator text-blue-600 text-lg"></i>
        </div>
      </div>
    </div>

    <!-- Total Cajas abiertas -->
    <div class="rounded-lg shadow-sm p-3 sm:p-4 border-l-4 border-yellow-500">
      <div class="flex items-center gap-3">
        <div class="flex-1 min-w-0">
          <p class="text-gray-600 text-xs font-medium">Cajas abiertas</p>
          <p class="text-base sm:text-lg font-bold text-gray-900 mt-1">
            {{ resumenReporte()!.total_cajas_abiertas }}
          </p>
        </div>
        <div class="p-2 bg-yellow-100 rounded shrink-0">
          <i class="bi bi-unlock text-yellow-600 text-lg"></i>
        </div>
      </div>
    </div>

    <!-- Total de cajas cerradas -->
    <div class="rounded-lg shadow-sm p-3 sm:p-4 border-l-4 border-red-500">
      <div class="flex items-center gap-3">
        <div class="flex-1 min-w-0">
          <p class="text-gray-600 text-xs font-medium">Cajas cerradas</p>
          <p class="text-base sm:text-lg font-bold text-gray-900 mt-1">
            {{ resumenReporte()!.total_cajas_cerradas }}
          </p>
        </div>
        <div class="p-2 bg-red-100 rounded shrink-0">
          <i class="bi bi-lock text-red-600 text-lg"></i>
        </div>
      </div>
    </div>
  </div>
}

<!-- Tabla de movimientos -->
<app-tabla
  titulo="Movimientos de Caja"
  [columnas]="columnasTabla"
  [datos]="paginacion()?.data || []"
  [accionesTemplate]="accionesTemplate"
/>
<ng-template #accionesTemplate let-row>
  <button
    type="button"
    class="text-blue-600 hover:text-blue-800 font-medium text-sm inline-flex items-center gap-1 transition-colors"
    (click)="verDetallesMovimiento(row)"
  >
    <i class="bi bi-eye"></i>
    <span class="hidden sm:inline">Ver</span>
  </button>
</ng-template>
<!-- estado abierto/cerrado -->
<ng-template #estadoTemplate let-row>
  <span
    [class]="
      'inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ' +
      (row.cerrada === false ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800')
    "
  >
    <i [class]="(row.cerrada === false ? 'bi bi-unlock-fill' : 'bi bi-lock-fill') + ' mr-1'"></i>
    {{ row.cerrada === false ? 'Abierto' : 'Cerrado' }}
  </span>
</ng-template>
<ng-template #diferenciaTemplate let-row>
  <span
    [class]="
      'inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold ' +
      (row.diferencia < 0
        ? 'bg-red-100 text-red-800'
        : row.diferencia > 0
          ? 'bg-yellow-100 text-yellow-800'
          : 'bg-green-100 text-green-800')
    "
  >
    <i
      [class]="
        (row.diferencia < 0
          ? 'bi bi-dash-circle-fill'
          : row.diferencia > 0
            ? 'bi bi-exclamation-circle-fill'
            : 'bi bi-check-circle-fill') + ' mr-1'
      "
    ></i>
    {{ row.diferencia | currency: 'PEN' : 'S/. ' }}
  </span>
</ng-template>
<!-- sucursal -->
<ng-template #sucursalColumnTemplate let-row>
  {{ row.sucursal_id | nombreSucursal }}
</ng-template>
@if (paginacion() != null) {
  <app-paginacion
    [items]="paginacion()!.data"
    [itemsPorPagina]="paginacion()!.size"
    [totalItems]="paginacion()!.total"
    (paginaCambiada)="cambiarPagina($event)"
  />
}
<app-dialog
  header="Detalles del Movimiento de Caja"
  [modal]="true"
  [(visible)]="modal_ver_movimientos_abiertos"
  size="xl"
  styleClass="sm:max-w-4xl"
  (onHide)="movimiento_seleccionado = null; modal_ver_movimientos_abiertos.set(false)"
>
  @if (modal_ver_movimientos_abiertos() == true && movimiento_seleccionado) {
    <div class="space-y-6">
      <!-- Estado -->
      <div class="flex justify-end">
        <span
          class="px-3 py-1 rounded-full text-xs font-semibold"
          [class.bg-red-100]="movimiento_seleccionado.cerrada"
          [class.text-red-700]="movimiento_seleccionado.cerrada"
          [class.bg-green-100]="!movimiento_seleccionado.cerrada"
          [class.text-green-700]="!movimiento_seleccionado.cerrada"
        >
          {{ movimiento_seleccionado.cerrada ? 'Caja cerrada' : 'Caja abierta' }}
        </span>
      </div>
      <!-- Información del usuario -->
      <div class="bg-gray-50 rounded-lg p-4 border">
        <h4 class="text-sm font-semibold text-gray-700 mb-3">Responsable de la caja</h4>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
          <div>
            <span class="text-gray-500">Nombre completo</span>
            <p class="font-medium text-gray-800">
              {{ movimiento_seleccionado.usuario_nombre_completo }}
            </p>
          </div>
          <div>
            <span class="text-gray-500">Email</span>
            <p class="font-medium text-gray-800">
              {{ movimiento_seleccionado.usuario_email }}
            </p>
          </div>
        </div>
      </div>

      <!-- Apertura -->
      <div class="bg-white rounded-lg p-4 border">
        <h4 class="text-sm font-semibold text-gray-700 mb-3">Apertura de Caja</h4>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
          <div>
            <span class="text-gray-500">Hora de apertura</span>
            <p class="font-medium">
              {{ movimiento_seleccionado.hora_apertura | date: 'dd/MM/yyyy HH:mm' }}
            </p>
          </div>
          <div>
            <span class="text-gray-500">Monto apertura</span>
            <p class="font-semibold text-green-600">
              {{ movimiento_seleccionado.monto_apertura | currency: 'PEN' : 'S/. ' }}
            </p>
          </div>
          <div class="md:col-span-2">
            <span class="text-gray-500">Motivo</span>
            <p class="text-gray-700">
              {{ movimiento_seleccionado.motivo_apertura || '—' }}
            </p>
          </div>
        </div>
      </div>

      <!-- Cierre -->
      <div class="bg-gray-50 rounded-lg p-4 border">
        <h4 class="text-sm font-semibold text-gray-700 mb-3">Cierre de Caja</h4>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
          <div>
            <span class="text-gray-500">Hora de cierre</span>
            <p class="font-medium">
              {{
                movimiento_seleccionado.hora_cierre
                  ? (movimiento_seleccionado.hora_cierre | date: 'dd/MM/yyyy HH:mm')
                  : 'Caja abierta'
              }}
            </p>
          </div>

          <div>
            <span class="text-gray-500"
              >Ventas realizadas
              <i
                class="bi bi-info-circle text-green-500 text-xs cursor-help"
                appTooltip="Corresponde a la suma de venta.total de todas las ventas realizadas durante el turno de caja. No incluye egresos ni vuelto."
                tooltipPosition="top"
              ></i>
            </span>
            <p class="font-medium text-green-600">
              {{ movimiento_seleccionado.total_ventas_brutas ?? 0 | currency: 'PEN' : 'S/. ' }}
            </p>
          </div>

          <div>
            <span class="text-gray-500">Total esperado (sistema)</span>
            <p class="font-medium text-blue-600">
              {{
                movimiento_seleccionado.total_esperado_caja ??
                  movimiento_seleccionado.monto_cierre_sistema | currency: 'PEN' : 'S/. '
              }}
            </p>
          </div>

          <div>
            <span class="text-gray-500">Efectivo esperado</span>
            <p class="font-medium text-indigo-600">
              {{
                movimiento_seleccionado.efectivo_esperado ??
                  movimiento_seleccionado.monto_cierre_efectivo | currency: 'PEN' : 'S/. '
              }}
            </p>
          </div>

          <div>
            <span class="text-gray-500">Egresos del turno</span>
            <p class="font-medium text-amber-600">
              {{ movimiento_seleccionado.total_egresos ?? 0 | currency: 'PEN' : 'S/. ' }}
            </p>
          </div>

          <div>
            <span class="text-gray-500">Monto reportado</span>
            <p class="font-medium">
              {{ movimiento_seleccionado.monto_cierre_reportado | currency: 'PEN' : 'S/. ' }}
            </p>
          </div>

          <div class="md:col-span-2">
            <span class="text-gray-500">Motivo cierre</span>
            <p class="text-gray-700">
              {{ movimiento_seleccionado.motivo_cierre_reportado || '—' }}
            </p>
          </div>
        </div>
      </div>

      <!-- Diferencia -->
      <div
        class="rounded-lg p-4 border"
        [class.bg-red-50]="movimiento_seleccionado.diferencia < 0"
        [class.bg-green-50]="movimiento_seleccionado.diferencia === 0"
        [class.bg-yellow-50]="movimiento_seleccionado.diferencia > 0"
      >
        <div class="flex items-center justify-between">
          <span class="text-sm font-semibold text-gray-700">Diferencia</span>
          <span
            class="text-lg font-bold"
            [class.text-red-600]="movimiento_seleccionado.diferencia < 0"
            [class.text-green-600]="movimiento_seleccionado.diferencia === 0"
            [class.text-yellow-600]="movimiento_seleccionado.diferencia > 0"
          >
            {{ movimiento_seleccionado.diferencia | currency: 'PEN' : 'S/. ' }}
          </span>
        </div>
      </div>
      <!-- botón cerrar -->
      <div class="flex justify-center">
        <button
          type="button"
          (click)="modal_ver_movimientos_abiertos.set(false)"
          class="w-full px-4 py-2.5 bg-gray-200 text-gray-700 font-medium rounded-lg hover:bg-gray-300 transition-colors text-sm"
        >
          Cerrar
        </button>
      </div>
    </div>
  }
</app-dialog>
